import HttpRequest from './axios'
import config from '@/config'
console.log('baseUrl', config.baseUrl)
console.log('env_type', process.env.VUE_APP_ENV_TYPE)
const axios = new HttpRequest(config.baseUrl)

export default axios
